export const searchForm = {
  project: undefined, // 品牌ID
  type: undefined, // 事业群
  site_keyword: undefined, // 网站名称
  platform_class: [] // 平台分类
}

export const form = {
  project: '',
  project_name: '',
  type: '',
  type_name: '',
  platform_class: undefined,
  domain: '',
  platform_name: undefined
}

export const detailForm = {
  project: '',
  type: '',
  platform_class: undefined,
  page_route: '',
  data_type_one: undefined,
  domain: ''
}

export const addForm = {
  site_id: '',
  page_route: '',
  page_title: ''
}

export const rules = {
  project: [{ required: true, message: '请选择平台', trigger: 'change' }],
  platform_class: [{ required: true, message: '请选择平台分类', trigger: 'change' }],
  domain: [{ required: true, message: '请输入域名', trigger: 'change' }],
  platform_name: [{ required: true, message: '请输入名称', trigger: 'change' }],
  page_route: [{ required: true, message: '请输入名称', trigger: 'change' }],
  page_title: [{ required: true, message: '请输入名称', trigger: 'change' }]
}
